import { gql } from '@apollo/client';

export const UPDATE_FINANCIAL_PRODUCT_RULE_FILTERS = gql`
  mutation updateFinancialProductRuleFilters($input: FinancialProductRuleFiltersInput) {
    updateFinancialProductRuleFilters(input: $input) {
      commandId
      correlationId
    }
  }
`;
